import React from 'react';
export function TablePageShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-15143">
      <span className="sr-only" data-id="element-15144">Loading table…</span>
      {/* Header with button */}
      <div className="flex justify-between items-center" data-id="element-15145">
        <div className="h-6 w-48 bg-gray-200 rounded" data-id="element-15146" />
        <div className="h-10 w-32 bg-gray-200 rounded-md" data-id="element-15147" />
      </div>
      {/* Stats cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-15148">
        {[1, 2, 3, 4].map(i => <div key={i} className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-15149">
            <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-15150" />
            <div className="h-8 w-32 bg-gray-200 rounded mb-2" data-id="element-15151" />
            <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-15152" />
          </div>)}
      </div>
      {/* Table */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-15153">
        {/* Table header */}
        <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-15154">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-15155" />
          <div className="h-10 w-64 bg-gray-200 rounded-md" data-id="element-15156" />
        </div>
        {/* Table content */}
        <div className="overflow-x-auto" data-id="element-15157">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-15158">
            <thead data-id="element-15159">
              <tr data-id="element-15160">
                {[1, 2, 3, 4, 5].map(i => <th key={i} className="px-4 py-3" data-id="element-15161">
                    <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-15162" />
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-15163">
              {[1, 2, 3, 4, 5, 6, 7, 8].map(i => <tr key={i} data-id="element-15164">
                  {[1, 2, 3, 4, 5].map(j => <td key={j} className="px-4 py-4" data-id="element-15165">
                      <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-15166" />
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="p-4 border-t border-gray-200 flex justify-between items-center" data-id="element-15167">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-15168" />
          <div className="flex gap-2" data-id="element-15169">
            {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-8 bg-gray-200 rounded" data-id="element-15170" />)}
          </div>
        </div>
      </div>
    </div>;
}